module.exports = __webpack_public_path__ + "static/media/500003.b8482dbf.svg";